import { Button, Modal, Typography, Form } from "antd";
import User from "models/user/user";

import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useLocation } from "react-router-dom";

export default function UserVerificationModal({
  isModalOpen,
  setIsModalOpen,
  email,
}) {
  const [btnLoading, setBtnLoading] = useState({
    submit: false,
    resend: false,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [otpValue, setOtpValue] = useState("");
  const [form] = Form.useForm();
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setOtpValue("");
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setOtpValue("");
  };
  const { Title, Paragraph, Text } = Typography;
  const userVerification = async () => {
    // setOtpValue(otp);
    const data = { Email: email, code: otpValue };
    setBtnLoading((prev) => {
      return { ...prev, submit: true };
    });
    const response = await User.verifyUser(data, queryParams);
    setBtnLoading((prev) => {
      return { ...prev, submit: false };
    });
  };
  const handleResendCode = async () => {
    setBtnLoading((prev) => {
      return { ...prev, resend: true };
    });

    await User.resendVerificationEmail({ Email: email });
    setBtnLoading((prev) => {
      return { ...prev, resend: false };
    });
    setOtpValue("");
    form.setFieldsValue({ otp: null });
  };

  return (
    <Modal
      className="cm-modal auth-modal"
      open={isModalOpen}
      centered
      onOk={handleOk}
      onCancel={handleCancel}
      footer={false}
      closeIcon={<i className="icon-close"></i>}
    >
      <Title level={3} className="text-center">
        <i className="icon-lock"></i>Two-Factor Authentication
      </Title>
      <Paragraph className="mb-0 text-center auth-modal-txt first-heading">
        Your account has been configured to use two-factor authentication.
      </Paragraph>
      <Paragraph className="auth-modal-txt text-center">
        Your OTP Code has been sent to {email}
      </Paragraph>
      {/* <div className="authenticator-wrap d-flex">
        <div className="num-input-wrap">
          <InputNumber min={1} max={1} />
        </div>
        <div className="num-input-wrap">
          <InputNumber min={1} max={100} />
        </div>
        <div className="num-input-wrap">
          <InputNumber min={1} max={100} />
        </div>
        <div className="num-input-wrap">
          <InputNumber min={1} max={100} />
        </div>
        <div className="num-input-wrap">
          <InputNumber min={1} max={100} />
        </div>
      </div> */}

      <div className="authenticator-wrap d-flex">
        <Form form={form} onFinish={userVerification}>
          <Form.Item
            name="otp"
            rules={[
              { required: true, message: "Please Enter OTP" },
              { min: 6, message: "Please enter valid OTP" },
            ]}
          >
            <OtpInput
              value={otpValue}
              onChange={(otp) => setOtpValue(otp)}
              numInputs={6}
              separator={<span> &nbsp;&nbsp;</span>}
              shouldAutoFocus={true}
            />
          </Form.Item>
        </Form>
      </div>
      <div className="auth-modal-btn-wrap mt-5">
        <Button
          type="primary"
          size="large"
          loading={btnLoading.submit}
          onClick={() => {
            form.submit();
          }}
        >
          Submit
        </Button>
        <Button
          type="primary"
          ghost
          size="large"
          className="resend-btn"
          loading={btnLoading.resend}
          onClick={handleResendCode}
        >
          Resend
        </Button>
      </div>
    </Modal>
  );
}
